import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

jQuery(document).ready(function () {
    // updateDropdowns();


    let selectors = document.querySelectorAll('.arrowDown');
    if(selectors){
        selectors.forEach((node) => {
            node.addEventListener('click', (e) => {
                if(!e.currentTarget.classList.contains('active')){
                    e.preventDefault();
                }
                e.currentTarget.classList.toggle('active');
                e.currentTarget.parentNode.querySelector('ul').classList.toggle('active')
                return false;
            })
        })
    }


    jQuery('#popUpServiceType').click(() => {
        jQuery('.hero_banner_dropdown').toggleClass('active');
    })


    jQuery('.hero_banner_dropdown_item').click(() => {
        jQuery('.hero_banner_dropdown').removeClass('active');
    })

    /*jQuery('.mobileSiteWrapper .dropdownItemParent').click((item) => {
        item.toggleClass('active');
        return false;
    })*/


});

jQuery(".arrowDown").on('mouseover', function () {
    updateDropdowns();
});

jQuery('.menu-item-has-children .menu-item-has-children>a').each(function() {
    if ( !jQuery(this).hasClass('arrowDown') ) {
        jQuery(this).addClass('arrowDown');
    }
});

function showLogin() {
    jQuery('body').addClass('popUpOpened');
    jQuery('#mainPopup').show();
    jQuery('#mainPopupLogin').show();
}

function updateDropdowns() {
    jQuery(".dropdown").each(function () {
        var documentWidth = jQuery(document).width();
    
        var distanceFromBottom = documentWidth - (jQuery(this).offset().left + jQuery(this).width());
    
        if(distanceFromBottom < 0) {
            jQuery(this).addClass('popLeft');
        }
    });
}

jQuery(".passwordDD").on('keyup', function () {       
    var passwordDD = jQuery('#password').val(); 
    var confirmPassword = jQuery('#confirm_password').val(); 
    // var message = ""

    if(passwordDD != confirmPassword) {
        // message += "The password not are not the same. Please try another."
    }

    if(parseInt(passwordDD.length) < 6 || parseInt(confirmPassword.length) < 6) {
        // message += "Your password must be at least 6 characters long. Please try another."        
        jQuery(".progressBarPS > div").removeClass('passwordStrong');
        jQuery(".progressBarPS > div").addClass('passwordWeak');
        jQuery(".passwordStrength_1").show();
        jQuery(".passwordStrength > label").removeClass("passwordStrongColor");    
    }

    if(parseInt(passwordDD.length) > 5 && parseInt(confirmPassword.length) > 5) {
        jQuery(".progressBarPS > div").removeClass('passwordWeak');
        jQuery(".progressBarPS > div").addClass('passwordStrong');
        jQuery(".passwordStrength > label").addClass("passwordStrongColor");    
        jQuery(".passwordStrength > label").text("Strong");        
        jQuery(".passwordStrength_1").hide();                
    }

});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = jQuery('.bottom-cta').outerHeight();

jQuery(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = jQuery(this).scrollTop();
    
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        jQuery('.bottom-cta').removeClass('scroll-up').addClass('scroll-down');
    } else {
        // Scroll Up
        if(st + jQuery(window).height() < jQuery(document).height()) {
            jQuery('.bottom-cta').removeClass('scroll-down').addClass('scroll-up');
        }
    }
    
    lastScrollTop = st;
}

jQuery('.live_chat_launch').click(() =>{
    jQuery('.live-chat-header-button a img').trigger('click');
});

let nav_trig = document.querySelector('.mobile_nav_trigger');
if(nav_trig){
    let overlay = document.querySelector('.overlay');
    let mob_close = document.querySelector('.mob_close');
    let nav_wrap = document.querySelector('.mobile_navigation');
    nav_trig.addEventListener('click', () => {
        nav_wrap.classList.add('active');
        overlay.classList.add('active');
    })
    if(overlay) {
        overlay.addEventListener('click', () => {
            nav_wrap.classList.remove('active');
            overlay.classList.remove('active');
        })

        mob_close.addEventListener('click', () => {
            nav_wrap.classList.remove('active');
            overlay.classList.remove('active');
        })
    }
}


let banner_btns = document.querySelectorAll('.hero_banner_button');
let white_label_button = document.querySelector('.white_label_button');
let whiteLabel = document.querySelector('.single-whitelabel_site');
if(banner_btns && whiteLabel){
    const host = window.location.href;
    let link = white_label_button.getAttribute('href');
    if (link.includes('clinic.doctorsondemand.com.au') && (host.includes('feature.doctorsondemand.com.au') || host.includes('dev-doctors-on-demand.pantheonsite.io'))) {
        link = link.replace('clinic.doctorsondemand.com.au', 'clinicfeature.doctorsondemand.com.au')
    } else if (link.includes('clinic.doctorsondemand.com.au') && (host.includes('test.doctorsondemand.com.au') || host.includes('test-doctors-on-demand.pantheonsite.io'))) {
        link = link.replace('clinic.doctorsondemand.com.au', 'clinictest.doctorsondemand.com.au');
    }

    banner_btns.forEach(btn => {
        btn.setAttribute('onclick', 'window.location.href="'+link+'"');
        btn.textContent = 'Book Now';
    })
}


let media_slider = document.querySelector('.slide_wrapper');
if(media_slider){

    new Flickity(media_slider, {
        // options
        cellAlign: 'center',
        contain: false,
        prevNextButtons: false,
        pageDots: true,
    });
}

let videoPlayers = document.querySelectorAll('.image_widget_play_icon');
if (videoPlayers) {
    videoPlayers.forEach((item) => {
        item.addEventListener('click', (evt) => {
            evt.currentTarget.parentNode.classList.add('active');
            let iframe = evt.currentTarget.parentNode.querySelector('.embed_wrap iframe');
            iframe.src = iframe.dataset.src;
        })
    })
}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
	    window.dispatchEvent(new Event('resize'));
    }, 10);

    setTimeout(function () {
	    window.dispatchEvent(new Event('resize'));
    }, 100);

    setTimeout(function () {
	    window.dispatchEvent(new Event('resize'));
    }, 500);
});